import styled from 'styled-components'

export const Title5 = styled.p.attrs({ className: 'title is-5' })``
export const Title6 = styled.p.attrs({ className: 'title is-6' })``
